// Components, Layouts, Pages
import { MainLayout } from '~/layouts';
import { SignInCommonPage } from '~/pages/common';
import { NotFoundPage } from '~/components/common';
// Others
// Styles, images, icons
import { IRouteModel } from '~/utils/interface/base';

export const authRoute = {
  base: '/auth',
  login: '/login',
};

export const authRoutes: IRouteModel[] = [
  {
    path: `${authRoute.base}`,
    component: MainLayout,
    children: [
      {
        index: true,
        path: `${authRoute.base}`,
        component: SignInCommonPage,
      },
    ],
  },
  {
    path: '*',
    component: NotFoundPage,
  },
];

export const authRouteAbsolute = {
  login: `${authRoute.base}${authRoute.login}`,
};
